// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { longText } from "@hardwoods/App/Widgets/DesignSystem/DummyData";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Modal from "@insite/mobius//Modal";
import Button from "@insite/mobius/Button/Button";
import { GridItem } from "@insite/mobius/index";
import Typography from "@insite/mobius/Typography";
import React, { useState } from "react";

export const XdlModal = () => {
    const [state, setState] = useState({ open: false });
    const openModal = () => {
        setState({ open: true });
    };

    const closeModal = () => {
        setState({ open: false });
    };

    return (
        <GridItem width={12}>
            <Button onClick={openModal}>Open Modal</Button>
            <Modal
                isOpen={state.open}
                handleClose={closeModal}
                headline="Transactional modal title"
                contentLabel="the basic modal"
            >
                <Typography variant="p">{longText}</Typography>
                <StyledWrapper className="modal-footer">
                    <Button onClick={closeModal}>Okay</Button>
                    <Button variant="secondary" onClick={closeModal}>
                        Cancel
                    </Button>
                </StyledWrapper>
            </Modal>
        </GridItem>
    );
};
